import { render } from "./deps-structure-view.vue?vue&type=template&id=453715f5"
import script from "./deps-structure-view.vue?vue&type=script&lang=js"
export * from "./deps-structure-view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/deps-structure-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "453715f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453715f5', __exports__)) {
    api.reload('453715f5', __exports__)
  }
  
  module.hot.accept("./deps-structure-view.vue?vue&type=template&id=453715f5", () => {
    api.rerender('453715f5', render)
  })

}


export default __exports__